import { yufaMarked } from "./lianxi-yufa-item-view.js";
import { verdictSounds } from "./lianxi-verdict-sounds.js";

/** Play the review's short verdict sounds after an exercise answer. */
export function feedbackYufa(block: HTMLElement): void {
  const hear = verdictSounds(block.ownerDocument);

  block.addEventListener(yufaMarked, (event) => {
    const detail = (
      event as CustomEvent<{ passed: boolean; unverified?: boolean }>
    ).detail;

    if (detail?.unverified === true) {
      return;
    }

    hear(detail?.passed);
  });
}
